import {injectable} from "inversify";
import {YouthPlayer} from "@/modules/youth/entity";
import {ScoutingCompletedNotification} from "@/modules/youth/entity/ScoutingCompletedNotification";

@injectable()
export default class NotificationCreator {
  public async createScoutingComplete(player: YouthPlayer) {
    return new ScoutingCompletedNotification().setPayload(player);
  }
}
